/**
 * Chargement paresseux d’ExcelJS (écriture des classeurs .xlsx) : la bibliothèque est lourde
 * et n’est téléchargée qu’au premier export. Elle ne sert jamais à LIRE un fichier externe
 * (la lecture passe par le lecteur borné `import/xlsx/SafeXlsxReader`).
 */
import type * as ExcelJsTypes from 'exceljs';

export type ExcelJsModule = typeof ExcelJsTypes;

export async function chargerExcelJs(): Promise<ExcelJsModule> {
  const mod = await import('exceljs');
  const avecDefaut = mod as { default?: ExcelJsModule };
  return avecDefaut.default ?? mod;
}

/** Copie un tampon de sortie d’ExcelJS dans un ArrayBuffer autonome. */
export function versArrayBuffer(raw: ArrayBuffer | Uint8Array): ArrayBuffer {
  const bytes = raw instanceof Uint8Array ? raw : new Uint8Array(raw);
  const copy = new ArrayBuffer(bytes.byteLength);
  new Uint8Array(copy).set(bytes);
  return copy;
}
